const HEADER_MOD = {
        "Do you have a simple, streamlined agent desktop with the digital tools needed to service today’s modern customers?": {
        header: "Agent Experience",
        negCopy:"Give agents a single, unified desktop to help them manage customer interactions across channels, increase efficiency, and improve the customer experience.",
        negLink:"",
        negLinkTxt:"",    
    },
        "Are customers able to troubleshoot service issues using automated tools?": {
        header: "Digital Service",
        negCopy:"Automated self-service helps customers resolve issues on their own terms, reduce service costs, and lighten the load on agents.",    
        negLink:"",
        negLinkTxt:"",    
    },
        "Are you able to derive insights from your customer data and provide proactive customer service?": {
        header: "Proactive Service",
        negCopy:"Use data to predict when your customers need help so you can offer proactive service at the right time and in the right place.",   
        negLink:"",
        negLinkTxt:"",    
    },
        "Do you have knowledge embedded in your agent and customer experiences through self-service tools, search, or proactively surfaced articles?": {
        header: "Knowledge Management",
        negCopy:"Lead your agents and customers to the exact answer to their question with intelligent, contextual search that serves up the best answer quickly, regardless of channel.", 
        negLink:"",
        negLinkTxt:"",     
    },
        "Do your agents have automated tools that help them provide personalized advice and decision-making?": {
        header: "Decision Automation",
        negCopy:"Provide consistent, personalized advice and decisions across all channels and in any language with advice and decision automation.",  
        negLink:"",
        negLinkTxt:"",    
    },
        "Are you able to collect and integrate data from multiple systems and applications to get a holistic view of your customers?": {
        header: "Data and Integration",
        negCopy:"Create a unified view of the customer by connecting online and offline data sources across sales, marketing, service, finance, HR, and supply chain systems.",   
        negLink:"",
        negLinkTxt:"",    
    },
        "Approximately how much of your customer service agents’ time is spent on manual tasks and processes?": {
        header: "Process Automation",
        negCopy:"Automate tasks and processes to boost agent productivity and allow agents to focus on high-value interactions.", 
        negLink:"",
        negLinkTxt:"",    
    },
        "Do agents have the insights and tools they need to generate revenue through cross-sell and up-sell during service interactions?": {
        header: "Revenue Generation",
        negCopy:"Turn service into a profit center by guiding agents with next-best actions and recommendations that help them cross-sell and upsell.",
        negLink:"",
        negLinkTxt:"",       
    },
        "Do you provide next-best action recommendations for your service agents?": {
        header: "Guided Assistance",
        negCopy:"Use customer data to determine the next-best steps to take with your customers and guide agents to help them resolve issues quickly. ",  
        negLink:"",
        negLinkTxt:"",     
    },
        "Can agents get a 360-degree view of account, customer, order, and service history in a single screen?": {
        header: "Customer 360",
        negCopy:"Connect your data across advertising, sales, marketing, and service with operational systems in finance, supply chain, and HR to deliver consistent, personalized experiences throughout the customer journey.", 
        negLink:"",
        negLinkTxt:"",      
    },
        "Do you offer customer service through the digital, social, and messaging channels your customers prefer to use?": {
        header: "Digital Channels",
        negCopy:"Allow customers to get help anytime, anywhere, through any channel they prefer, including digital, social, messaging, and mobile.",    
        negLink:"",
        negLinkTxt:"",    
    },
        "Are your applications integrated across all customer touchpoints to give you a full view of your customers’ journey?": {
        header: "Application Integration",
        negCopy:"Create a unified view of the customer by connecting online and offline data sources across all your CRM, ERP, and other data sources.",   
        negLink:"",
        negLinkTxt:"",    
    },
        "What percentage of your field service work is scheduled by artificial intelligence?": {
        header: "Service Scheduling",
        negCopy:"Organizations using schedule automation tools can reduce unproductive activities by 15% or more, both for technicians and dispatchers. Schedule automation tools can also increase customer satisfaction through better SLA compliance and first-time fix rates.", 
        negLink:"",
        negLinkTxt:"",      
    },
        "Can field technicians see a full 360-degree view of your customer, including accurate account information, installed asset data, plus order and service history?": {
        header: "Customer 360 ",
        negCopy:"The field service team of the present and the future will need to tap into a broad base of up-to-date, relevant, and on-demand data on the asset, equipment, and customer to resolve issues.", 
        negLink:"",
        negLinkTxt:"",      
    },
        "Can a field service technician order and ship a spare part to a customer to resolve a service request from their mobile device?": {
        header: "Service Logistics",
        negCopy:"Connecting your field service activities with your supply chain streamlines parts ordering, parts fulfillment, trunk stock management, service debriefing, and invoicing.", 
        negLink:"",
        negLinkTxt:"",    
    },
        "Do your field service teams have access to knowledge articles and videos on their mobile device?": {
        header: "Service Knowledge",
        negCopy:"Sharing best practices helps turn tribal learnings and silos into community knowledge. Top-performing field service organizations have exhibited the ability to preserve and share the knowledge of its most experienced team members to all relevant stakeholders.",  
        negLink:"",
        negLinkTxt:"",      
    },
        "Can your field teams use guided repair and video collaboration to get expert support?": {
        header: "Technician Support",
        negCopy:"Service organizations can improve technician productivity by using video streaming and augmented reality products for expert guidance. Remote technicians and agents see what the field technician sees and provide guidance in real-time.", 
        negLink:"",
        negLinkTxt:"",      
    },
        "Can your customers track their on-site service events, and see who is coming and when they will arrive?": {
        header: "Customer Experience",
        negCopy:"Companies like Uber and Lyft have raised customer expectations for field service. Customers expect field service organizations to provide a similar experience with tools that enable real-time visibility into service events.",    
        negLink:"",
        negLinkTxt:"",    
    },
        "Which of the following statements best describes how your service processes and technology impact employee experience:": {
        header: "Employee Experience",
        negCopy:"Agents need a unified toolset that helps them manage communications across channels and bridge the gap between self-service and agent-assisted service.", 
        negLink:"",
        negLinkTxt:"",    
    },
        "Do you align service with other business functions to improve customer experiences and identify revenue-generating opportunities?": {
        header: "Efficiency",
        negCopy:"CX is a team sport.  To deliver amazing customer experiences, align service with your other business functions.",   
        negLink:"",
        negLinkTxt:"",     
    },
        "How much revenue do you expect to capture from service engagements in the next 12 months?": {
        header: "Growth",
        negCopy:"Many service organizations have been told to transform from a cost center to a profit center. But without access to the right tools and data, it’s impossible for agents to become trusted advisors and up-sellers. ", 
        negLink:"",
        negLinkTxt:"",      
    },
        "Choose the statement that best describes your CSAT/NPS scores over the past 12 months:": {
        header: "Customer Experience ",
        negCopy:"Customers expect service agents to know exactly who they are, what their history is, and what they want, without having to repeat themselves.",  
        negLink:"",
        negLinkTxt:"",    
    },
    "Can you deliver seamless, 24/7 service options across your digital channels?": {
        header: "Digital Transformation",
        negCopy:"Consumers' expectations have gone digital, and there's no turning back. You need to deliver the seamless and instantaneous service experiences they’ve come to prefer from the many consumer apps they engage with daily.",  
        negLink:"",
        negLinkTxt:"",    
    },
        "Which best describes how your service delivery impacts your brand perception:": {
        header: "Brand Differentiation",
        negCopy:"With intuitive automation, service delivery on your customers' terms, seamless experiences, and data-driven personalization, you can drive loyalty, revenue, customer value, and differentiate your brand. ",   
        negLink:"",
        negLinkTxt:"",    
    },
}
export default HEADER_MOD;